import { computed } from 'mobx';
import { inject, observer } from 'mobx-react';
import React from 'react';

import Attachment from './controls/attachment';

interface IProps {
  clinicalStore?: any;
}

@inject('vm', 'clinicalStore')
@observer
class AttachmentsTable extends React.Component<IProps> {
  render() {
    if (!this.show) return null;

    let { attachments } = this.props.clinicalStore.prontoStore;

    let content = attachments.map((x: any, i: number) => {
      return <Attachment key={i} {...x} />;
    });

    return (
      <table className="attachments-table">
        <thead>
          <tr>
            <th>Name</th>
            <th className="date">Date Created</th>
            <th className="unit">Type</th>
            <th className="unit">Size</th>
            <th className="unit"></th>
          </tr>
        </thead>
        <tbody>{content}</tbody>
      </table>
    );
  }

  @computed
  get show() {
    let { status, attachments, reports } = this.props.clinicalStore.prontoStore;
    return status === 'fullfilled' && attachments.length > 0;
  }
}

export default AttachmentsTable;
